// Scale-aware numeric formatting helpers.
// Mirrors backend/marqolix/exchanges/simulator.py::_price_decimals so that
// sub-cent tokens (e.g. LMCSWAP @ $0.0004) don't render as "$0.00" in the UI.

export function priceDecimals(v) {
  const p = Math.abs(Number(v) || 0);
  if (p >= 1000) return 2;
  if (p >= 1) return 4;
  if (p >= 0.01) return 6;
  if (p > 0) return 8;
  return 2;
}

export function fmtPrice(v, { withDollar = false } = {}) {
  const n = Number(v);
  if (!isFinite(n)) return withDollar ? "$—" : "—";
  const d = priceDecimals(n);
  const s = n.toFixed(d);
  return withDollar ? `$${s}` : s;
}

export function fmtUsd(v) {
  const n = Number(v) || 0;
  // never show "$0.00" for non-zero sub-cent values
  if (n !== 0 && Math.abs(n) < 0.01) return `$${n.toFixed(6)}`;
  return `$${n.toFixed(2)}`;
}
